import React from 'react';
import classNames from 'classnames';
import { DATA_RATING } from '../../../common/constants/data-attributes';
import { useTranslate } from '../../context/api-context/translations/use-translate';
import { RATING_DISPLAY } from '../../../common/constants/data-hooks';
import { StarIcon } from './star-icon';
import { Stars } from '../../../ui';
import styles from './ratings-display.module.scss';
export const RatingsDisplay = ({ className, rating = 0, isPending = false, }) => {
    const t = useTranslate();
    return (React.createElement("div", { "data-hook": RATING_DISPLAY, [DATA_RATING]: rating },
        React.createElement(Stars, { icon: StarIcon, gap: "small", className: classNames(styles.root, Boolean(isPending) && styles.isPending, className), a11yLabel: t('ratings-display.rating-aria-label', { rating }), rating: rating })));
};
//# sourceMappingURL=ratings-display.js.map